const C = require("../constants");
const initial_data = {open: false, ticket:{id:null, name:' ', price:0, has_expiration:false, expiration_days:0}};

function TicketDialogReducer(state = initial_data, action) {
    switch (action.type) {
        case C.TICKET_DIALOG:
            return action.data;
        default:
            return state;
    }
}

export default TicketDialogReducer;


// WEBPACK FOOTER //
// ./src/reducers/TicketDialogReducer.js